<template>
    <div class="footer">
        <div class="container">
            <div class="contacts">
                <slot name="contacts"></slot>
            </div>
            <div class="categories">
                <slot name="categories"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "FooterContainer"
    };
</script>

<style scoped lang="scss">
    .footer {
        background-color: #3F4450;
        padding: 45px 0 40px;
        width: 100%;
        .container {
            display: flex;
            .contacts {
                max-width: 280px;
            }
            .categories {
                flex: 1;
            }
        }
    }
</style>
